import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { ReservationsGraph } from './components/ReservationGraphs';

const Income: React.FC = () => {
  return (
    <>
      <Typography variant="h4">Gráficos</Typography>
      <Box mt={2}>
        <ReservationsGraph />
      </Box>
    </>
  );
};

export { Income };
